/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * Collimator
 * The Collimator API description (multi-version)
 * OpenAPI spec version: 1.0.0
 */
import { fetchApi } from "../../../../fetch";
import type {
  ClassesControllerFindAllV0Params,
  ClassesControllerFindOneV0Params,
  ClassesControllerUpdateV0Params,
  CreateClassDto,
  DeletedClassDto,
  ExistingClassDto,
  ExistingClassExtendedDto,
  ExistingClassWithTeacherDto,
  UpdateClassDto,
} from "../../models";

export const getClassesControllerCreateV0Url = () => {
  return `/api/v0/classes`;
};

export const classesControllerCreateV0 = async (
  createClassDto: CreateClassDto,
  options?: RequestInit,
): Promise<ExistingClassDto> => {
  return fetchApi<ExistingClassDto>(getClassesControllerCreateV0Url(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createClassDto),
  });
};

export const getClassesControllerFindAllV0Url = (
  params?: ClassesControllerFindAllV0Params,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v0/classes?${stringifiedParams}`
    : `/api/v0/classes`;
};

export const classesControllerFindAllV0 = async (
  params?: ClassesControllerFindAllV0Params,
  options?: RequestInit,
): Promise<ExistingClassWithTeacherDto[]> => {
  return fetchApi<ExistingClassWithTeacherDto[]>(
    getClassesControllerFindAllV0Url(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getClassesControllerFindOneV0Url = (
  id: number,
  params?: ClassesControllerFindOneV0Params,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v0/classes/${id}?${stringifiedParams}`
    : `/api/v0/classes/${id}`;
};

export const classesControllerFindOneV0 = async (
  id: number,
  params?: ClassesControllerFindOneV0Params,
  options?: RequestInit,
): Promise<ExistingClassExtendedDto> => {
  return fetchApi<ExistingClassExtendedDto>(
    getClassesControllerFindOneV0Url(id, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getClassesControllerUpdateV0Url = (
  id: number,
  params?: ClassesControllerUpdateV0Params,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v0/classes/${id}?${stringifiedParams}`
    : `/api/v0/classes/${id}`;
};

export const classesControllerUpdateV0 = async (
  id: number,
  updateClassDto: UpdateClassDto,
  params?: ClassesControllerUpdateV0Params,
  options?: RequestInit,
): Promise<ExistingClassDto> => {
  return fetchApi<ExistingClassDto>(
    getClassesControllerUpdateV0Url(id, params),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateClassDto),
    },
  );
};

export const getClassesControllerRemoveV0Url = (id: number) => {
  return `/api/v0/classes/${id}`;
};

export const classesControllerRemoveV0 = async (
  id: number,
  options?: RequestInit,
): Promise<DeletedClassDto> => {
  return fetchApi<DeletedClassDto>(getClassesControllerRemoveV0Url(id), {
    ...options,
    method: "DELETE",
  });
};
